import { LanguageCodes } from '~/enums/LanguageCodes'

const getGenderKeywords = () => {
  const locale = useState<string>('locale.setting')

  switch (locale.value) {
    case LanguageCodes.Lithuanian: {
      return {
        male: 'Vyrams',
        female: 'Moterims',
      }
    }
    case LanguageCodes.Latvian: {
      return {
        male: 'Vīriešiem',
        female: 'Sievietēm',
      }
    }
    default: {
      return {
        male: 'Men',
        female: 'Women',
      }
    }
  }
}

export default (hierarchy?: string) => {
  if (!hierarchy) {
    return null
  }

  const keywords = getGenderKeywords()
  const hierarchyParts = hierarchy.split(' > ')

  const isMale = hierarchyParts.find((keyword) => keyword.toLowerCase() === keywords.male.toLowerCase())

  if (isMale != null) {
    return keywords.male
  }

  const isFemale = hierarchyParts.find((keyword) => keyword.toLowerCase() === keywords.female.toLowerCase())

  if (isFemale != null) {
    return keywords.female
  }

  return null
}
